<template>
  <div class="footer">
    <div class="batch">
      <div class="myMain">©Copyright PT Solusi kecerdasan artifisial</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.footer {
  background-color: #fff;
  text-align: center;
}
.batch {
  width: 100%;
  background-color: #f6f8f7;
  padding: 0.44rem 0;
  .myMain {
    text-align: center;
    color: #919594;
    font-size: 0.28rem;
  }
}
</style>
